// extracted by mini-css-extract-plugin
module.exports = {"header":"HeaderBack_header__23JSs","headerTitle":"HeaderBack_headerTitle__2_d1s","headerIconContainer":"HeaderBack_headerIconContainer__1rZYw"};